var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalFlowDeletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#E43E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.5L27.8803 24.5251C27.7219 27.0864 27.6428 28.3671 27.0008 29.2879C26.6833 29.7431 26.2747 30.1273 25.8007 30.416C24.8421 31 23.559 31 20.9927 31C18.4231 31 17.1383 31 16.179 30.4149C15.7048 30.1257 15.296 29.7408 14.9787 29.2848C14.3369 28.3626 14.2594 27.0801 14.1046 24.5152L13.5 14.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.5L27.8803 24.5251C27.7219 27.0864 27.6428 28.3671 27.0008 29.2879C26.6833 29.7431 26.2747 30.1273 25.8007 30.416C24.8421 31 23.559 31 20.9927 31C18.4231 31 17.1383 31 16.179 30.4149C15.7048 30.1257 15.296 29.7408 14.9787 29.2848C14.3369 28.3626 14.2594 27.0801 14.1046 24.5152L13.5 14.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5H30M25.0557 14.5L24.3731 13.0917C23.9196 12.1563 23.6928 11.6885 23.3017 11.3968C23.215 11.3321 23.1231 11.2745 23.027 11.2247C22.5939 11 22.0741 11 21.0345 11C19.9688 11 19.436 11 18.9957 11.2341C18.8981 11.286 18.805 11.3459 18.7173 11.4132C18.3216 11.7167 18.1006 12.2015 17.6586 13.1713L17.0529 14.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25.5V19.5",
    stroke: "#E43E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.5V19.5",
    stroke: "#E43E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalFlowDeletedIcon);
export default __webpack_public_path__ + "static/media/approval-flow-deleted-icon.1018184be203b1fbfcd232156ec7b9c2.svg";
export { ForwardRef as ReactComponent };